import styled from "@emotion/styled"

export const HorizontalDivider = styled.div({
  width: 20,
  height: 40,
  borderBottom: "1px solid black",
})

type VerticalDividerProps = {
  height: number
}
export const VerticalDivider = styled.div<VerticalDividerProps>(
  ({ height }) => ({
    width: 20,
    borderLeft: "1px solid black",
    position: "absolute",
    height,
    marginTop: 40,
  })
)
